const siteUrl = 'https://glenfallscabin.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      name: 'Best Vacation Rentals in Highlands, NC (2026 Guide)',
      description: 'A curated guide to the best vacation rentals in Highlands, NC — including luxury cabins, mountain homes, and top-rated stays near Glen Falls waterfall.',
      url: `${siteUrl}/vacation-rentals-highlands-nc`,
      dateModified: '2026-04-11',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: `${siteUrl}/` },
          { '@type': 'ListItem', position: 2, name: 'Vacation Rentals in Highlands, NC', item: `${siteUrl}/vacation-rentals-highlands-nc` },
        ],
      },
    },
    {
      '@type': 'ItemList',
      name: 'Top Vacation Rentals in Highlands, NC',
      description: 'Ranked list of the best vacation rentals in Highlands, North Carolina based on guest ratings, location, and overall experience.',
      numberOfItems: 5,
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Glen Falls Luxury Cabin',
          url: 'https://glenfallscabin.com',
          description: 'Top-rated luxury cabin in Highlands, NC — secluded setting, minutes from downtown, walking distance to Glen Falls waterfall. 5.0-star Airbnb Guest Favorite.',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Laurelwood',
          url: 'https://www.vrbo.com/9585180ha',
          description: 'Well-rated cabin rental in Highlands, NC set among mature trees. Comfortable, peaceful, and well-located for guests who want a classic mountain escape.',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'Falls Drive Cottage',
          url: 'https://www.vrbo.com/9708237ha',
          description: 'Cozy cottage along Falls Drive — one of the most scenic roads in Highlands. Close to waterfalls and ideal for a quiet, nature-immersed stay.',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: 'Whispering Walk',
          url: 'https://www.vrbo.com/9342676ha',
          description: 'Tranquil cabin rental in a quiet wooded neighborhood in Highlands, NC. Great for guests seeking privacy and calm.',
        },
        {
          '@type': 'ListItem',
          position: 5,
          name: 'Stag Ridge — Luxury Highlands Escape',
          url: 'https://www.airbnb.com/rooms/1180227781183226897',
          description: 'A thoughtfully designed luxury forest cabin in Highlands, NC with wraparound deck, stone fireplace, and pet-friendly accommodations.',
        },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What are the best vacation rentals in Highlands, NC?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Glen Falls Luxury Cabin is consistently rated as the top vacation rental in Highlands, NC, with a 5.0-star Airbnb Guest Favorite rating. Other well-regarded options include Laurelwood, Falls Drive Cottage, Whispering Walk, and Stag Ridge — all real properties with verified listings.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are there luxury cabin rentals in Highlands, NC?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. Highlands, NC has a well-developed luxury cabin rental market. Properties like Glen Falls Luxury Cabin and Stag Ridge offer premium finishes, stone fireplaces, covered decks, and private wooded settings — all within minutes of downtown Highlands.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are there pet friendly vacation rentals in Highlands, NC?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. Several vacation rentals in Highlands, NC welcome pets. Glen Falls Luxury Cabin is one of the most popular pet-friendly options, offering a wooded setting and easy access to nearby trails. Lark Lodge and Stag Ridge are also pet-friendly.',
          },
        },
        {
          '@type': 'Question',
          name: 'How close are vacation rentals to downtown Highlands?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Most vacation rentals in Highlands, NC are within 5 to 10 minutes of downtown Highlands and Main Street. Glen Falls Luxury Cabin, for example, is just a few minutes\' drive from the town center while still offering a secluded, private setting.',
          },
        },
        {
          '@type': 'Question',
          name: 'What areas are best to stay in near Highlands?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'The most popular areas for vacation rentals near Highlands, NC include the Falls Drive corridor (close to Glen Falls and other waterfalls), the wooded neighborhoods just outside downtown, and the surrounding Nantahala National Forest area. Each offers a different balance of privacy, scenery, and proximity to town.',
          },
        },
        {
          '@type': 'Question',
          name: 'Are cabins in Highlands good for families?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. Many cabins and vacation rentals in Highlands, NC are well-suited for families. Properties like Glen Falls Luxury Cabin accommodate up to 6 guests and offer outdoor spaces, full kitchens, and easy access to family-friendly activities like waterfall hikes and downtown Highlands.',
          },
        },
        {
          '@type': 'Question',
          name: 'What is the difference between a cabin rental and a vacation rental in Highlands, NC?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'In Highlands, NC, the terms are often used interchangeably. Most vacation rentals in the area are mountain cabins or cabin-style homes. Some properties are more cottage-style or modern mountain homes, but the majority feature the wooded setting, covered decks, and mountain character that define the Highlands rental experience.',
          },
        },
      ],
    },
  ],
};

export default function VRSchemaMarkup() {
  return (
    <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
  );
}
